<template>
    <div>
      <router-view/>
    </div>
  </template>
  
  <script>
  
  export default {
    name: "Layout",
    computed: {
      currentRouterName() {
        return this.$route.meta.title
      }
    },
    data() {
      return {
  
      }
    },
    methods: {

    }
  }
  </script>
  
  <style scoped>
  
  </style>